import { render } from "./CriarProduto.vue?vue&type=template&id=3844b457"
import script from "./CriarProduto.vue?vue&type=script&lang=js"
export * from "./CriarProduto.vue?vue&type=script&lang=js"
script.render = render

export default script